import { useEffect, useState } from "react";
// Components
import DirectoryBreadCrumb from "view/components/Breadcrumbs/DirectoryBreadCrumb";
import { PageHeading } from "./components";

const generateDynamicBreadcrumbLinks = () => {
  switch (true) {
    default:
      return [{ path: `/system-settings`, label: `Settings` }];
  }
};
export const Header = () => {
  const dynamicCommunityLinks = generateDynamicBreadcrumbLinks();

  return (
    <div className="flex items-start self-stretch justify-start flex-grow-0 flex-shrink-0">
      <div className="flex items-start self-stretch justify-start flex-grow">
        <div className="flex flex-col items-start justify-start flex-grow gap-2">
          <DirectoryBreadCrumb links={dynamicCommunityLinks} />
          <div className="flex items-start self-stretch justify-start flex-grow-0 flex-shrink-0 gap-2">
            <PageHeading />
          </div>
        </div>
      </div>
    </div>
  );
};
